import React from "react";
import idx from "idx";
import PanelGroup from "react-panelgroup";
import PropTypes from "prop-types";
import windowSize from "react-window-size";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose, bindActionCreators } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { EDITOR_ITEMS } from "../../constants";
import { objToArr, prepareItems } from "../../helpers";
import ActionCreators from "../../redux/actions";
import { convertCartesianToSpherical } from "../../helpers/coordinates";
import { uploadFile } from "../../helpers/fileHelpers";
import Styles from "./MapEditor.styles";
import LoadingOverlay from "../../components/LoadingOverlay";
import EditorLayout from "../../components/EditorLayout";
import Button from "../../components/UIKit/Button";
import Spacer from "../../components/Spacer";
import ProjectWidgets from "../../components/ProjectWidgets";
import ProjectName from "../../components/ProjectName";
import ScenesPanel from "../../components/ScenesPanel";
import Inspector from "../Inspector";
import { MapEditPanel } from "../../components/Map";
import MapContainer from "./MapContainer";
// test project id AA4LCwAABwcNCwMDBAEACw
import { setOrganization, focusEditorPanel } from "../../redux/actions/editor";
import {
  selectWidget,
  loadMap,
  removeWidget,
  updateMapRequest
} from "../../redux/actions/map";

const mapTypes = {
  TEST: "test",
  PROD: "prod"
};
class MapEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      mapType: mapTypes.TEST,
      uploadingFiles: {
        [mapTypes.TEST]: false,
        [mapTypes.PROD]: false
      },
      isGenerating: false
    };
    this.onSceneCreate = this.onSceneCreate.bind(this);
    this.onSceneDelete = this.onSceneDelete.bind(this);
    this.onSceneSelect = this.onSceneSelect.bind(this);
    this.onWidgetEditSubmit = this.onWidgetEditSubmit.bind(this);
    this.onMapSwitch = this.onMapSwitch.bind(this);
    this.onWidgetRemove = this.onWidgetRemove.bind(this);
    this.saveLayout = this.saveLayout.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);

    this.onMapDetailsEdit = this.onMapDetailsEdit.bind(this);
  }

  componentDidMount() {
    const isMapNotLoadedFromFirebase =
      Object.keys(this.props.firebaseMap).length === 0;
    if (isMapNotLoadedFromFirebase) {
      this.props.firebase
        .watchEvent(
          "once",
          `/projects/${this.props.match.params.projectId}/map`,
          null
        )
        .then(response => {
          const { data: { widgets = {}, connectors = {} } = {} } = response;
          const selectedWidget = Object.keys(widgets).reduce(
            (obj, currentKey) => {
              let tmp = { ...obj };
              if (widgets[currentKey].isMain) {
                tmp = widgets[currentKey];
              }
              return { ...tmp };
            },
            {}
          );
          this.props.loadMap(widgets, connectors, selectedWidget.id);
        })
        .catch(error => console.log(error));
    } else {
      const { widgets = {}, connectors = {} } = this.props.firebaseMap;
      const selectedWidget = Object.keys(widgets).reduce((obj, currentKey) => {
        let tmp = { ...obj };
        if (widgets[currentKey].isMain) {
          tmp = widgets[currentKey];
        }
        return { ...tmp };
      }, {});
      this.props.loadMap(widgets, connectors, selectedWidget.id);
    }
  }

  onMapDetailsEdit(data) {
    const { projectId } = this.props.match.params;
    const { testImage, prodImage, units, offset } = data;
    this.props.selectWidget(null);
    const options = {
      name: file => `${file.name}/${Date.now()}`
    };

    if (testImage && !this.state.uploadingFiles[mapTypes.TEST]) {
      this.setState({
        uploadingFiles: { ...this.state.uploadingFiles, [mapTypes.TEST]: true }
      });
      this.props.firebase
        .uploadFile(`files/${projectId}`, testImage[0], null, options)
        .then(snap => {
          const { uploadTaskSnaphot: { downloadURL = {} } = {} } = snap;
          this.props.firebase
            .updateWithMeta(`/projects/${projectId}/map/testImage/`, {
              downloadURL
            })
            .then(res => {
              this.setState({
                uploadingFiles: {
                  ...this.state.uploadingFiles,
                  [mapTypes.TEST]: false
                }
              });
            });
        })
        .catch(err => {
          console.log(err);
          this.setState({
            uploadingFiles: {
              ...this.state.uploadingFiles,
              [mapTypes.TEST]: false
            }
          });
        });
    }

    if (prodImage && !this.state.uploadingFiles[mapTypes.PROD]) {
      this.setState({
        uploadingFiles: { ...this.state.uploadingFiles, [mapTypes.PROD]: true }
      });
      uploadFile(
        this.props.firebase,
        `files/${projectId}/map/prodImage/`,
        `/projects/${projectId}/map/prodImage/`,
        prodImage[0]
      )
        .then(res => {
          this.setState({
            uploadingFiles: {
              ...this.state.uploadingFiles,
              [mapTypes.PROD]: false
            }
          });
        })
        .catch(err => {
          console.log(err);
          this.setState({
            uploadingFiles: {
              ...this.state.uploadingFiles,
              [mapTypes.PROD]: false
            }
          });
        });
    }
    this.props.firebase.updateWithMeta(`/projects/${projectId}/map`, { units });
    this.props.firebase.updateWithMeta(`/projects/${projectId}/map`, {
      offset
    });
    const { useProdImage } = data;
    this.onMapSwitch(useProdImage);
  }

  onImageLoad(imgWidth, imgHeight) {
    this.imageWidth = imgWidth;
    this.imageHeight = imgHeight;
  }

  onWidgetRemove(widget) {
    const { projectId } = this.props.match.params;
    this.props.removeWidget(widget.id, projectId);
  }

  onWidgetEditSubmit(data, path) {
    // @TODO change Inspector component and enable to return something else than path
    // retrieve widget id from path
    const widgetId = path.split("/").pop();
    const { projectId } = this.props.match.params;
    const { widgets, connectors } = this.props;
    const newWidgets = Object.keys(widgets).reduce((obj, key) => {
      const tmp = obj;
      tmp[key] = { ...widgets[key] };
      if (data.isMain) {
        if (widgets[key].id !== widgetId) {
          tmp[key] = { ...widgets[key], isMain: false };
        }
      }
      if (widgets[key].id === widgetId) {
        tmp[key] = { ...widgets[key], ...data };
      }
      return tmp;
    }, {});
    this.props.updateMap(newWidgets, connectors, projectId);
  }

  onMapSwitch(useProdMap) {
    this.setState({ mapType: useProdMap ? "prod" : "test" });
  }

  onSceneCreate(sceneData) {
    const { projectId } = this.props.match.params;
    sceneData.panorama.map((panorama, index) => {
      this.props.firebase
        .pushWithMeta(`/projects/${projectId}/scenes`, {
          name:
            sceneData.panorama.length > 1
              ? `${sceneData.name}_${index}`
              : sceneData.name
        })
        .then(snapshot => {
          if (sceneData.panorama && sceneData.panorama.length > 0) {
            const options = {
              name: file => `${file.name}/${Date.now()}`
            };
            this.props.setLoadingScene(snapshot.key);

            uploadFile(
              this.props.firebase,
              `files/${projectId}/${snapshot.key}/panorama`,
              `/projects/${projectId}/scenes/${snapshot.key}/panorama`,
              panorama
            ).then(() => this.props.setSceneLoaded(snapshot.key));
            return true;
          }
        });
    });
  }

  onSceneDelete(id) {
    const { projectId } = this.props.match.params;

    this.props.firebase.remove(`projects/${projectId}/scenes/${id}`);
  }

  onSceneSelect(props) {
    const { projectId } = this.props.match.params;
    const project = idx(this.props, _ => _.projects[projectId]);
    this.props.selectInspectorItem(props.id, EDITOR_ITEMS.SCENE);
    this.props.push(`/map-editor/${projectId}/${props.id}`);
  }

  saveLayout() {
    if (!this.imageWidth || !this.imageHeight) {
      return false;
    }
    /*
    To odpowiada za obrócenie renderów.Trzeba dorobić pole w edytorze
    */
    // const offset = -34;
    /*
    ##############################
    */
    this.setState({ isGenerating: true });

    const { projectId } = this.props.match.params;
    const fbProject = idx(this.props, _ => _.projects[projectId]);
    const connectors = idx(fbProject, _ => _.map.connectors) || [];
    // const { units: conversionFactor = 0.25 } = idx(fbProject, _ => _.map);
    const units = idx(fbProject, _ => _.map.units) || 0.25;
    const offset = parseFloat(idx(fbProject, _ => _.map.offset)) || 0;
    const updates = {};
    const calculateRelativeCoordinates = (
      objA,
      objB,
      imageWidth,
      imageHeight
    ) => ({
      x: objA.positionX * imageWidth - objB.positionX * imageWidth, //* conversionFactor,
      y: objA.positionY * imageHeight - objB.positionY * imageHeight, //* conversionFactor,
      z: ((objB.altitude || 165) - (objA.altitude || 165) - 165) / (100 * units)
    });

    const start = new Date().getTime();
    Object.entries(connectors).forEach(([key, element]) => {
      const { startWidget = null, endWidget = null } = element;

      if (startWidget) {
        if (!(startWidget.sceneId in updates)) {
          updates[startWidget.sceneId] = [];
        }

        let tmp = {
          name: endWidget.name || `Portal to: ${endWidget.sceneId}`,
          type: "portal",
          targetScene: endWidget.sceneId,
          rotation: "70",
          size: "200px"
        };
        const coordinates = calculateRelativeCoordinates(
          startWidget,
          endWidget,
          this.imageWidth,
          this.imageHeight
        );
        const sphericalCoordinates = convertCartesianToSpherical(
          coordinates.x,
          coordinates.y,
          coordinates.z
        );
        const convertedSCoord = {
          rho: sphericalCoordinates.rho,
          phi: sphericalCoordinates.theta,
          theta: sphericalCoordinates.phi + offset
        };

        tmp = { ...tmp, ...convertedSCoord };

        updates[startWidget.sceneId].push(tmp);
      }

      if (endWidget) {
        if (!(endWidget.sceneId in updates)) {
          updates[endWidget.sceneId] = [];
        }

        let tmp = {
          name: startWidget.name || `Portal to: ${startWidget.sceneId}`,
          type: "portal",
          targetScene: startWidget.sceneId,
          rotation: "70",
          size: "200px"
        };

        const coordinates = calculateRelativeCoordinates(
          endWidget,
          startWidget,
          this.imageWidth,
          this.imageHeight
        );

        const sphericalCoordinates = convertCartesianToSpherical(
          coordinates.x,
          coordinates.y,
          coordinates.z
        );

        const convertedSCoord = {
          rho: sphericalCoordinates.rho,
          phi: sphericalCoordinates.theta,
          theta: sphericalCoordinates.phi + offset
        };
        tmp = { ...tmp, ...convertedSCoord };
        updates[endWidget.sceneId].push(tmp);
      }
    });

    Promise.all(
      Object.entries(updates).map(([key, portals]) =>
        this.props.firebase
          .update(`/projects/${projectId}/scenes/${key}/layers/`, {
            _generated: { name: "_generated" }
          })
          .then(() => {
            const promises = [];
            portals.map(portal =>
              promises.push(
                this.props.firebase.pushWithMeta(
                  `/projects/${projectId}/scenes/${key}/layers/_generated/widgets`,
                  portal
                )
              )
            );
            return Promise.all(promises);
          })
      )
    ).then(() => {
      this.setState({ isGenerating: false });
    });
  }

  prepareItems(items, icon = null, disabledItems) {
    const output = objToArr(Object.assign({}, items)).map(item => {
      const tmp = item;
      tmp.id = tmp.key;
      tmp.text = tmp.name;
      if (icon) {
        tmp.icon = icon;
      }
      if (disabledItems && disabledItems.includes(tmp.key)) {
        tmp.secondaryIcon = "icon-portal";
      } else {
        tmp.secondaryIcon = null;
      }

      return tmp;
    });

    return output;
  }

  render() {
    let { projectId, sceneId } = this.props.match.params;
    const project = idx(this.props, _ => _.projects[projectId]);
    this.prepareItems(idx(project, _ => _.scenes), "icon-sphere");
    const currentProject = this.props.currentProject;
    const mapImageUrl =
      this.state.mapType === "prod"
        ? this.props.prodImageUrl
        : this.props.testImageUrl;
    if (!this.props.projectsRequested || !this.props.currentProjectRequested) {
      return <LoadingOverlay />;
    }

    // rewrite objects in redux to have id and key
    const fbProject = idx(this.props, _ => _.projects[projectId]);
    prepareItems(idx(fbProject, _ => _.map.widgets));
    prepareItems(idx(fbProject, _ => _.map.connectors));

    const widgets = idx(fbProject, _ => _.map.widgets) || [];
    const disabledItems = Object.keys(widgets).map(key => widgets[key].sceneId);
    const scenes = this.prepareItems(
      idx(currentProject, _ => _.scenes),
      "icon-sphere",
      disabledItems
    );
    if (!sceneId && scenes.length > 0) {
      sceneId = scenes[0].id;
    }
    return (
      <EditorLayout
        toolbar={[
          <ProjectName>{project.name || ""}</ProjectName>,
          <Button
            size="xs"
            onClick={() => {
              this.props.history.push(
                `/editor/${this.props.match.params.projectId}`
              );
            }}
          >
            Editor
          </Button>,
          <Button
            size="xs"
            onClick={() => {
              this.props.history.push(
                `/projects/${this.props.match.params.projectId}`
              );
            }}
          >
            Project settings
          </Button>
        ]}
        profile={this.props.profile}
        projects={objToArr(this.props.projects)}
        organizations={objToArr(this.props.organizations)}
        onLogoutClick={this.props.logout}
        onOrganizationClick={props => {
          this.props.setOrganization(props.id);
        }}
        onProjectClick={props => {
          this.props.push(`/editor/${props.id}`);
        }}
        currentOrganization={this.props.currentOrganizationId}
        match={this.props.match}
      >
        <PanelGroup
          borderColor={Styles.panelBorderColor}
          panelWidths={[
            { size: 250, minSize: 250, resize: "dynamic" },
            { minSize: 250, resize: "stretch" },
            { size: 300, minSize: 300, resize: "dynamic" }
          ]}
        >
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <ScenesPanel
              onClick={() => {
                this.props.focusEditorPanel("scenes");
              }}
              hasFocus={this.props.editor.focusedPanel === "scenes"}
              title={"Available scenes"}
              titleEditable
              selected={sceneId}
              onCreate={this.onSceneCreate}
              items={scenes}
              onItemClick={this.onSceneSelect}
              onDelete={this.onSceneDelete}
              style={{ flex: 1 }}
            />
            <MapEditPanel
              match={this.props.match}
              firebase={this.props.firebase}
              map={this.props.firebaseMap}
              onMapSwitch={this.onMapSwitch}
              saveLayout={this.saveLayout}
              onSubmit={this.onMapDetailsEdit}
              switchDisabled={
                this.state.uploadingFiles.test || this.state.uploadingFiles.prod
              }
            />
          </div>
          <div style={{ width: "100%" }}>
            <MapContainer
              match={this.props.match}
              mapImageUrl={mapImageUrl}
              onImageLoad={this.onImageLoad}
              isUploading={this.state.uploadingFiles[this.state.mapType]}
            />
          </div>
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Inspector
              match={this.props.match}
              onValidSubmit={this.onWidgetEditSubmit}
              onRemove={this.onWidgetRemove}
            />
          </div>
        </PanelGroup>

        {this.state.isGenerating && (
          <LoadingOverlay
            style={{ background: "rgba(0,0,0,0.4)", zIndex: 999 }}
          />
        )}
      </EditorLayout>
    );
  }
}

MapEditor.defaultProps = {
  match: {
    projectId: ""
  }
};

MapEditor.propTypes = {
  match: PropTypes.shape({
    projectId: PropTypes.string
  }).isRequired
};

function mapStateToProps({
  firebase,
  router,
  organizations,
  map,
  editor,
  inspector
}) {
  const { scene: sceneInspector = {} } = inspector;
  const { currentItemId: selectedSceneId = null } = sceneInspector;
  const { selectedWidget: selectedWidgetId, widgets, connectors } = map;
  const { map: firebaseMap = {} } = firebase.data;
  const {
    testImage: { downloadURL: testImageUrl = "" } = {},
    prodImage: { downloadURL: prodImageUrl = "" } = {}
  } =
    firebaseMap || {};
  return {
    currentOrganizationId: organizations.currentOrganizationId,
    auth: firebase.auth,
    currentProject: firebase.data.currentProject,
    currentProjectRequested: firebase.requested.currentProject,
    projects: firebase.data.projects,
    projectsRequested: firebase.requested.projects,
    location: router.location,
    users: firebase.data.users,
    editor,
    selectedWidgetId,
    firebaseMap: firebaseMap || {},
    organizations: firebase.data.organizations,
    map,
    prodImageUrl,
    testImageUrl,
    widgets,
    connectors,
    selectedWidget: map.selectedWidget,
    profile: firebase.profile,
    selectedSceneId
  };
}
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(ActionCreators, dispatch),
  updateMap: (widgets, connectors, projectId) => {
    dispatch(updateMapRequest(widgets, connectors, projectId));
  },
  push: path => {
    dispatch(push(path));
  },
  setOrganization: id => {
    dispatch(setOrganization(id));
  },
  selectWidget: widget => {
    dispatch(selectWidget(widget));
  },
  loadMap: (widgets, connectors, selectedWidget) => {
    dispatch(loadMap(widgets, connectors, selectedWidget));
  },
  removeWidget: (widget, projectId) => {
    dispatch(removeWidget(widget, projectId));
  }
});

export default compose(
  connect(({ firebase, organizations }) => ({
    auth: firebase.auth,
    currentOrganizationId: organizations.currentOrganizationId
  })),
  firebaseConnect(props => [
    {
      path: "/organizations",
      queryParams: [`orderByChild=members/${props.auth.uid}`, "equalTo=true"]
    },
    {
      path: "/projects",
      queryParams: [
        `orderByChild=organizations/${props.currentOrganizationId}`,
        "equalTo=true"
      ]
    },
    {
      path: `/projects/${props.match.params.projectId}`,
      storeAs: "currentProject"
    },
    {
      path: `/projects/${props.match.params.projectId}/map`,
      storeAs: "map"
    }
  ]),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(windowSize(MapEditor));



// WEBPACK FOOTER //
// ./src/containers/MapEditor/MapEditor.js